import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";
import { buildDayMessage, shareWhatsApp, waUrl } from "../lib/whatsapp";

export const WhatsAppShareButton = ({ date, day, testid = "whatsapp-share-button", label = "Share on WhatsApp" }) => {
  const [busy, setBusy] = useState(false);
  const share = async () => {
    if (day) return shareWhatsApp(buildDayMessage(day));
    const w = window.open("", "_blank");
    setBusy(true);
    try {
      const d = (await api.get("/day-entries", { params: { date: date || new Date().toLocaleDateString("en-CA") } })).data;
      w.location.href = waUrl(buildDayMessage(d));
    } catch (e) {
      w?.close();
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button onClick={share} disabled={busy} data-testid={testid}
      className="rounded-none bg-[#25D366] hover:bg-[#1ebe5b] text-white">
      <MessageCircle className="h-4 w-4 mr-1" /> {label}
    </Button>
  );
};
